export enum EThemeTemplate {
  HANTEC = 'HANTEC',
  DEFAULT = 'DEFAULT'
}

export const TENANT_THEMES_MAP: Record<string, EThemeTemplate> = {
  // hantec (in prod / uat ), demo2 (in sit / release-sit)
  hantec: EThemeTemplate.HANTEC,
  default: EThemeTemplate.DEFAULT
};
